import React, { FC } from 'react';

import { propsHelperRem, SvgProps } from '@/shared/lib/propsHelper';

export const FacebookIcon: FC<SvgProps> = (props) => (
    <svg {...propsHelperRem(2.4, 2.4, props)}>
        <path
            d="M21 12.055a9 9 0 1 0-10.406 8.89v-6.289H8.309v-2.601h2.285v-1.983c0-2.256 1.343-3.502 3.4-3.502.983 0 2.014.176 2.014.176v2.215h-1.135c-1.118 0-1.467.694-1.467 1.406v1.688h2.496l-.399 2.601h-2.097v6.29C17.71 20.27 21 16.545 21 12.054Z"
            fill="#fff"
        />
    </svg>
);
